import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

/**
 * This file contains the messages for the site wide title and the helmet title formatting.
 * Messages for the section titles and page titles are defined in the messages files of the
 * respective section, e.g Mortgage, Payments, etc.
 */

const IDS = {
  FORMAT_PAGETITLE_SECTIONTITLE_SITETITLE: 'helmetMessages.format.pageTitle.sectionTitle.siteTitle',
  FORMAT_SECTIONTITLE_SITETITLE: 'helmetMessages.format.sectionTitle.siteTitle',
  FORMAT_SITETITLE: 'helmetMessages.format.siteTitle',
  SITETITLE: 'helmetMessages.siteTitle',
};

const enMessages = {
  [IDS.FORMAT_PAGETITLE_SECTIONTITLE_SITETITLE]: '{pageTitle} - {sectionTitle} - {siteTitle}',
  [IDS.FORMAT_SECTIONTITLE_SITETITLE]: '{sectionTitle} - {siteTitle}',
  [IDS.FORMAT_SITETITLE]: '{siteTitle}',
  [IDS.SITETITLE]: 'Your Loan Servicing Center',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.SITETITLE]: 'Your Account Servicing Center',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
